import { render } from "./skema-gaji-list.vue?vue&type=template&id=046b4a42&scoped=true"
import script from "./skema-gaji-list.vue?vue&type=script&lang=js"
export * from "./skema-gaji-list.vue?vue&type=script&lang=js"

import "./skema-gaji-list.vue?vue&type=style&index=0&id=046b4a42&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046b4a42"]])

export default __exports__